
import { App } from 'vue';
import GalleryBox from './GalleryBox.vue';

interface PluginOptions {
    componentName?: string;
}

export let params: PluginOptions = {
    componentName: 'GalleryBox',
};

export function install(app: App, args: PluginOptions = {}): void {
    params = Object.assign(params, args)
    app.component(params.componentName, GalleryBox);
}
